import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import { ReactComponent as WarningIcon } from '../img/icons/warning.svg';
import { ReactComponent as WarningIconWhite } from '../img/icons/warning-white.svg';
import { UIContext } from '../context/UIContext';

const SkipStepPopup = ({
  open,
  handleClose,
  handleSkip,
  popupTitle,
  popupDescription,
  cancelButtonText,
  skipButtonText,
}: {
  open: boolean;
  handleClose: () => void;
  handleSkip: () => void;
  popupTitle: string;
  popupDescription: string;
  cancelButtonText?: string;
  skipButtonText?: string;
}) => {
  const { t } = useTranslation();
  const { colorMode } = useContext(UIContext);

  return (
    <Dialog
      open={open}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle
        sx={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          textAlign: 'center',
          alignItems: 'center',
          gap: '1.5rem',
          padding: '1.5rem 1.5rem 0.75rem 1.5rem',
        }}
        component={Box}
      >
        {colorMode === 'light' ? <WarningIcon /> : <WarningIconWhite />}
        <Typography variant="h2">{popupTitle}</Typography>
        <Typography variant="body1">{popupDescription}</Typography>
      </DialogTitle>

      <DialogActions
        sx={{
          padding: '0.75rem 1.5rem 1.5rem 1.5rem',
        }}
      >
        <Button
          variant="outlined"
          sx={{
            margin: '0px',
            flexGrow: '0',
            height: '48px',
          }}
          onClick={handleClose}
        >
          {cancelButtonText || t('actions.cancel')}
        </Button>
        <Button
          variant="contained"
          sx={{
            margin: '0px',
            flexGrow: '0',
            height: '48px',
          }}
          onClick={handleSkip}
        >
          {skipButtonText || t('actions.skip')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default SkipStepPopup;
